import { render } from "./BookCard.vue?vue&type=template&id=bcbfe69c&scoped=true"
import script from "./BookCard.js?vue&type=script&lang=js&external"
export * from "./BookCard.js?vue&type=script&lang=js&external"

import "./BookCard.css?vue&type=style&index=0&id=bcbfe69c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcbfe69c"]])

export default __exports__